import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export function useLayout(layouts) {
  const router = useRouter()
  const route = useRoute()
  const isInitialized = ref(false)

  const currentLayout = computed(() => {
    const layoutName = route.meta.layout || 'auth'
    return layouts[layoutName]
  })

  onMounted(async () => {
    await router.isReady()
    isInitialized.value = true
  })

  return {
    currentLayout,
    isInitialized,
  }
}
